<template>
  <div class="StaffManage-list">
    <GlobalInfoBar title="区域管理" content="管理分区及查看分区所含门店" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <GlobalForm
          class="global-form"
          :init-data="initData"
          :form-item-list="formItemList"
          :inline="true"
          :labelWidth="100"
          :needBtnLoading="true"
          round
          @handleConfirm="handleConfirm"
          confirmBtnName="查询"
        >
          <el-button
            icon="el-icon-plus"
            slot="AddSlot"
            type="primary"
            @click="AddReGionFn"
            >添加区域</el-button
          >
        </GlobalForm>
      </div>
      <!-- <StaffManageTable /> -->
      <GlobalTable
        ref="GlobalTable"
        v-loading="loading"
        :columns="regiondatatitle"
        :data="this.redenvellist"
        :currentPage="page.pageNum"
        :pageSize="10"
        :total="page.total"
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column label="区域门店" slot="storeNum" align="center">
          <template slot-scope="{ row }">
            <span
              :class="[row.storeNum ? 'storeNum' : '']"
              @click="storeNum(row)"
              >{{ row.storeNum ? row.storeNum : "--" }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="区域总监" slot="inspectorName" align="center">
          <template slot-scope="{ row }">
            <span
              >{{ row.inspectorName ? row.inspectorName : "--" }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="总监联系方式" slot="contactPhone" align="center">
          <template slot-scope="{ row }">
            <span
              >{{ row.contactPhone ? row.contactPhone : "--" }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="操作" slot="caozuo" align="center">
          <template slot-scope="{ row }">
            <!-- <el-button type="primary" size="mini" @click="FN(row)"
              >新增门店</el-button
            > -->
            <el-button size="mini" type="danger" @click="DelFN(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog
      title="删除提示"
      :visible.sync="deltoact"
      :close-on-click-modal="false"
      width="500px"
      @closed="closeDialogStore"
    >
      <div class="deltop1txt">说明：删除之后门店和总监无归属分区</div>

      <div class="delcen2txt">是否确认删除该区域？</div>

      <div class="delbtn3">
        <el-button size="small" @click="delbtnclose">取消</el-button>
        <el-button type="primary" @click="delsure" size="small">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加区域"
      :visible.sync="addregion"
      :close-on-click-modal="false"
      width="500px"
      @closed="closeDialogStore"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="区域名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请填写区域名称，最多8个字"
            maxlength="8"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="选择总监" prop="region">
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择总监"
            clearable
            filterable
            class="elformitem"
          >
            <el-option
              v-for="item in ruleFormdata"
              :key="item.staffId"
              :label="item.staffName"
              :value="item.staffId"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- <div class="btnoutbox">
          <el-button @click="btnoutbox">取消</el-button>
          <el-button
            class="btnclose"
            type="primary"
            @click="resetForm('ruleForm')"
            >确定</el-button
          >
        </div> -->

        <div class="delbtn3" style="padding-top: 0px">
          <el-button size="small" @click="btnoutbox">取消</el-button>
          <el-button type="primary" @click="btngobox('ruleForm')" size="small"
            >确认</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <DialogTbale
      @onClose="onClose"
      :show="staffVisible"
      title="区域门店列表"
      :columns="DialogTableColumns"
      :data="DialogDataList"
      :currentPage="pageson.pageNum"
      :total="pageson.total"
      :pageSize="10"
      :width="1000"
      @handleCurrentChange="handleCurrentChangeDialog"
    >
      <div style="margin-bottom: 20px">
        <span style="margin-left: 10px"
          ><b>{{ this.DialogDataList[0].areaName }}</b></span
        >
        <span style="margin-left: 350px"
          >管理门店：{{ this.pageson.total }}个</span
        >
      </div>
 <el-table-column label="门店店长" slot="storeManager" align="center">
          <template slot-scope="{ row }">
            <!-- <el-button type="primary" size="mini" @click="FN(row)"
              >新增门店</el-button
            > -->
            <span>{{row.storeManager || '--'}}</span>
          </template>
        </el-table-column>

<el-table-column label="店长联系方式" slot="storeManagerPhone" align="center">
          <template slot-scope="{ row }">
            <!-- <el-button type="primary" size="mini" @click="FN(row)"
              >新增门店</el-button
            > -->
            <span>{{row.storeManagerPhone || '--'}}</span>
          </template>
        </el-table-column>
    </DialogTbale>
  </div>
</template>

<script >
import _api from "@/utils/request";
export default {
  components: {},
  data() {
    return {
      areaId: "", //区域ID
      ruleFormdata: [],
      pageson: {
        pageNum: 1,
        total: 2,
        pageSize: 10,
      },
      staffVisible: false, //弹窗表格
      ruleForm: {
        name: "",
        region: "",
      },
      addregion: false, //新增区域
      deltoact: false, //刪除區域
      initData: null,
      loading: false,
      page: {
        pageNum: 1,
        total: 10,
      },
      datastr: {},
      //   select form data
      formItemList: [
        {
          key: "areaName",
          type: "input",
          labelName: "区域名称",
          placeholder: "请输入区域名称",
        },
        {
          key: "inspectorName",
          type: "input",
          labelName: "区域总监",
          placeholder: "请输入总监名称",
        },
        {
          key: "contactPhone",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
        },
      ],
      regiondatatitle: [
        { label: "分区名称", prop: "areaName" },
        { label: "添加时间", prop: "createTime" },
        // { label: "区域总监", prop: "inspectorName" },
        // { label: "总监联系方式", prop: "contactPhone" },
        { slotName: "inspectorName" },
        { slotName: "contactPhone" },
        // { label: "区域门店", prop: "storeNum" },
        { slotName: "storeNum" },
        // { label: "操作", prop: "refund" },
        { slotName: "caozuo" }, //caozuo
        // { label: "当前红包余额（元）", prop: "balance" },
      ],
      redenvellist: [],

      DialogTableColumns: [
        { label: "门店名称", prop: "storeName" },
        // { label: "门店店长", prop: "storeManager" },
        { slotName: "storeManager" },
        { slotName: "storeManagerPhone" },
        // { label: "登录手机号", prop: "storeManagerPhone" },
        { label: "店员数量", prop: "staffCount" },
        // { label: "店长联系方式", prop: "cashOut" },
        // // { label: "操作", prop: "refund" },
        // { slotName: "caozuo" }, //caozuo
      ],
      DialogDataList: [{ areaName: "" }],
      rules: {
        name: [
          { required: true, message: "请输入区域名称", trigger: "blur" },
          { min: 0, max: 8, message: "最多输入八个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    _api.arealist({ pageNum: 1, pageSize: 10 }).then((res) => {
      console.log(res);
      this.redenvellist = res.data.records;
      this.page = { pageNum: res.data.current, total: res.data.total };
    });
  },
  mounted() {},
  methods: {
    // /// 上面的注释始终代表下面的方法

    handleConfirm(data,cd) {
      console.log(data, "查询打印");
      let datastr = {
        areaName: data.areaName || "",
        inspectorName: data.inspectorName || "",
        contactPhone: data.contactPhone || "",
        pageNum: 1,
        pageSize: 10,
      };

      this.datastr = datastr;
      _api.arealist(datastr).then((res) => {
        console.log(res);
        this.redenvellist = res.data.records;
        this.page = { pageNum: res.data.current, total: res.data.total };
        cd()
      });
    },
    // list翻页方法
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      let datastr = {
        areaName: this.datastr.areaName || "",
        inspectorName: this.datastr.inspectorName || "",
        contactPhone: this.datastr.contactPhone || "",
        pageNum: this.page.pageNum,
        pageSize: 10,
      };

      this.datastr = datastr;
      _api.arealist(datastr).then((res) => {
        console.log(res);
        this.redenvellist = res.data.records;
        this.page = { pageNum: res.data.current, total: res.data.total };
      });
    },
    handleCurrentChangeDialog(val) {
      if (val) {
        this.pageson.pageNum = val;
      } else {
        this.pageson.pageNum = 1;
      }

      _api
        .StaffManageList({
          areaId: this.areaId,
          pageNum: this.pageson.pageNum,
          pageSize: 10,
        })
        .then((res) => {
          console.log(res, "门店数量");
          this.DialogDataList = res.data.records;
          this.pageson = { total: res.data.total, pageNum: res.data.current };
          this.staffVisible = true;
        });
    },
    closeDialogStore() {},
    // 添加区域
    AddReGionFn() {
      this.addregion = true;
      this.ruleForm = { name: "", region: "" };
      _api.getNotPInspectorSelect({ scope: "01" }).then((res) => {
        console.log(res, "总监");
        this.ruleFormdata = res.data;
      });
    },
    // 删除方法
    DelFN(row) {
      // if(row.inspectorName && !row.isQuit){
      //    this.$message({
      //     message: "已关联总监的区域不可删除",
      //     type: "warning",
      //   });
      //   return
      // }
      this.areaId = row.id;
      this.deltoact = true;
    },
    // 删除弹窗取消按钮
    delbtnclose() {
      this.deltoact = false;
    },
    // 删除弹窗确定按钮
    delsure() {
      _api.arearemoveById({ areaId: this.areaId }).then((res) => {
        console.log(res, "删除");
        this.deltoact = false;
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.handleCurrentChange();
      });
    },
    // 添加弹窗取消按钮
    btnoutbox() {
      this.addregion = false;
    },
    // 添加弹窗确定按钮
    btngobox(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm.name, this.ruleForm.name);

          let savedata = {
            areaName: this.ruleForm.name,
            inspectorId: this.ruleForm.region || "",
          };
          _api.areasave(savedata).then((res) => {
            console.log(res, "保存");
            this.addregion = false;
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.handleCurrentChange();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 门店数量点击
    storeNum(row) {
      console.log(row);
      console.log("门店数量");
      this.areaId = row.id;
      _api
        .StaffManageList({ areaId: row.id, pageNum: 1, pageSize: 10 })
        .then((res) => {
          console.log(res, "门店数量");
          this.DialogDataList = res.data.records;
          this.pageson = { total: res.data.total, pageNum: res.data.current };
          this.staffVisible = true;
        });
    },
    // 门店数量弹窗关闭
    onClose() {
      this.staffVisible = false;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage-list {
  .button_top {
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn {
    width: 280px;
    height: 42px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      background: #0981ff;
      border-radius: 20px;
    }
    .right {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
}

.deltop1txt {
  color: red;
  font-size: 14px;
}

.delcen2txt {
  text-align: center;
  margin-top: 20px;
}

.delbtn3 {
  padding: 40px 150px 20px 140px;
  display: flex;
  justify-content: space-between;
}

/deep/.elformitem {
  width: 360px;
}
/deep/.btnoutbox {
  width: 100%;
  //   display: flex;
  //   justify-content: space-between !important;

  margin-left: calc(50% - 75px);
  margin-bottom: 20px;
}
/deep/.btnclose {
  margin-left: 30px !important;
}

.storeNum {
  text-decoration: underline;
  cursor: pointer;
  color: #0981ff;
}
</style>

